exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-kontakt-jsx": () => import("./../../../src/pages/kontakt.jsx" /* webpackChunkName: "component---src-pages-kontakt-jsx" */),
  "component---src-pages-moje-sprawy-jsx": () => import("./../../../src/pages/moje-sprawy.jsx" /* webpackChunkName: "component---src-pages-moje-sprawy-jsx" */)
}

